(() => {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire708f"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire708f"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("hzVqu", function(module, exports) {
module.exports = $;

});

parcelRegister("du6ua", function(module, exports) {

$parcel$export(module.exports, "jQuery", () => $9d131b95ad68a144$export$1ea89ccd920d3a7, (v) => $9d131b95ad68a144$export$1ea89ccd920d3a7 = v);
/*jslint browser: true*/ /*jslint jquery: true*/ /*
 * jQuery Hotkeys Plugin
 * Copyright 2010, John Resig
 * Dual licensed under the MIT or GPL Version 2 licenses.
 *
 * Based upon the plugin by Tzury Bar Yochay:
 * https://github.com/tzuryby/jquery.hotkeys
 *
 * Original idea by:
 * Binny V A, http://www.openjs.com/scripts/events/keyboard_shortcuts/
 */ /*
 * One small change is: now keys are passed by object { keys: '...' }
 * Might be useful, when you want to pass some other data to your handler
 */ (function(jQuery1) {
    jQuery1.hotkeys = {
        version: "0.2.0",
        specialKeys: {
            8: "backspace",
            9: "tab",
            10: "return",
            13: "return",
            16: "shift",
            17: "ctrl",
            18: "alt",
            19: "pause",
            20: "capslock",
            27: "esc",
            32: "space",
            33: "pageup",
            34: "pagedown",
            35: "end",
            36: "home",
            37: "left",
            38: "up",
            39: "right",
            40: "down",
            45: "insert",
            46: "del",
            59: ";",
            61: "=",
            96: "0",
            97: "1",
            98: "2",
            99: "3",
            100: "4",
            101: "5",
            102: "6",
            103: "7",
            104: "8",
            105: "9",
            106: "*",
            107: "+",
            109: "-",
            110: ".",
            111: "/",
            112: "f1",
            113: "f2",
            114: "f3",
            115: "f4",
            116: "f5",
            117: "f6",
            118: "f7",
            119: "f8",
            120: "f9",
            121: "f10",
            122: "f11",
            123: "f12",
            144: "numlock",
            145: "scroll",
            173: "-",
            186: ";",
            187: "=",
            188: ",",
            189: "-",
            190: ".",
            191: "/",
            192: "`",
            219: "[",
            220: "\\",
            221: "]",
            222: "'"
        },
        shiftNums: {
            "`": "~",
            "1": "!",
            "2": "@",
            "3": "#",
            "4": "$",
            "5": "%",
            "6": "^",
            "7": "&",
            "8": "*",
            "9": "(",
            "0": ")",
            "-": "_",
            "=": "+",
            ";": ": ",
            "'": "\"",
            ",": "<",
            ".": ">",
            "/": "?",
            "\\": "|"
        },
        // excludes: button, checkbox, file, hidden, image, password, radio, reset, search, submit, url
        textAcceptingInputTypes: [
            "text",
            "password",
            "number",
            "email",
            "url",
            "range",
            "date",
            "month",
            "week",
            "time",
            "datetime",
            "datetime-local",
            "search",
            "color",
            "tel"
        ],
        // default input types not to bind to unless bound directly
        textInputTypes: /textarea|input|select/i,
        options: {
            filterInputAcceptingElements: true,
            filterTextInputs: true,
            filterContentEditable: true
        }
    };
    function keyHandler(handleObj) {
        if (typeof handleObj.data === "string") handleObj.data = {
            keys: handleObj.data
        };
        // Only care when a possible input has been specified
        if (!handleObj.data || !handleObj.data.keys || typeof handleObj.data.keys !== "string") return;
        var origHandler = handleObj.handler, keys = handleObj.data.keys.toLowerCase().split(" ");
        handleObj.handler = function(event) {
            //      Don't fire in text-accepting inputs that we didn't directly bind to
            if (this !== event.target && (jQuery1.hotkeys.options.filterInputAcceptingElements && jQuery1.hotkeys.textInputTypes.test(event.target.nodeName) || jQuery1.hotkeys.options.filterContentEditable && jQuery1(event.target).attr('contenteditable') || jQuery1.hotkeys.options.filterTextInputs && jQuery1.inArray(event.target.type, jQuery1.hotkeys.textAcceptingInputTypes) > -1)) return;
            var special = event.type !== "keypress" && jQuery1.hotkeys.specialKeys[event.which], character = String.fromCharCode(event.which).toLowerCase(), modif = "", possible = {};
            jQuery1.each([
                "alt",
                "ctrl",
                "shift"
            ], function(index, specialKey) {
                if (event[specialKey + 'Key'] && special !== specialKey) modif += specialKey + '+';
            });
            // metaKey is triggered off ctrlKey erronously
            if (event.metaKey && !event.ctrlKey && special !== "meta") modif += "meta+";
            if (event.metaKey && special !== "meta" && modif.indexOf("alt+ctrl+shift+") > -1) modif = modif.replace("alt+ctrl+shift+", "hyper+");
            if (special) possible[modif + special] = true;
            else {
                possible[modif + character] = true;
                possible[modif + jQuery1.hotkeys.shiftNums[character]] = true;
                // "$" can be triggered as "Shift+4" or "Shift+$" or just "$"
                if (modif === "shift+") possible[jQuery1.hotkeys.shiftNums[character]] = true;
            }
            for(var i = 0, l = keys.length; i < l; i++){
                if (possible[keys[i]]) return origHandler.apply(this, arguments);
            }
        };
    }
    jQuery1.each([
        "keydown",
        "keyup",
        "keypress"
    ], function() {
        jQuery1.event.special[this] = {
            add: keyHandler
        };
    });
})(jQuery || $9d131b95ad68a144$export$1ea89ccd920d3a7 || window.jQuery);

});

parcelRegister("3zknA", function(module, exports) {

$parcel$export(module.exports, "noop", () => $10c0da8dfb629bed$export$8793edee2d425525);
$parcel$export(module.exports, "randomInt", () => $10c0da8dfb629bed$export$3c5f89dae98e900b);
$parcel$export(module.exports, "randomBool", () => $10c0da8dfb629bed$export$b3b584c8d6ffe165);
$parcel$export(module.exports, "swapInArray", () => $10c0da8dfb629bed$export$5da6d711ed0fd711);
$parcel$export(module.exports, "shuffleArray", () => $10c0da8dfb629bed$export$7ac3a88d34a76e7);
$parcel$export(module.exports, "fitText", () => $10c0da8dfb629bed$export$b94583dc679500d);
$parcel$export(module.exports, "checkWrittenAnswer", () => $10c0da8dfb629bed$export$6a06ec76c9af6d6c);
$parcel$export(module.exports, "parseBoolean", () => $10c0da8dfb629bed$export$3fb54149990fb5b5);
$parcel$export(module.exports, "scrollIntoView", () => $10c0da8dfb629bed$export$53a0910f038337bd);
$parcel$export(module.exports, "isEnterEvent", () => $10c0da8dfb629bed$export$edd1eb89fbbc58a4);
$parcel$export(module.exports, "isEscapeEvent", () => $10c0da8dfb629bed$export$27297757fabc3b9);
$parcel$export(module.exports, "callLater", () => $10c0da8dfb629bed$export$19d86ed52b89834e);
$parcel$export(module.exports, "cardTextOnly", () => $10c0da8dfb629bed$export$bdf91b169a64e21c);

var $hzVqu = parcelRequire("hzVqu");
parcelRequire("lUnw9");

var $3wPZM = parcelRequire("3wPZM");

var $jR4nF = parcelRequire("jR4nF");
const $10c0da8dfb629bed$var$log = console.log;
// const log = noop;
const $10c0da8dfb629bed$var$MONTH_DAYS = 30;
const $10c0da8dfb629bed$var$DAY_SECONDS = 86400;
const $10c0da8dfb629bed$var$HOUR_SECONDS = 3600;
function $10c0da8dfb629bed$export$8793edee2d425525() {}
function $10c0da8dfb629bed$export$3c5f89dae98e900b(endExclusive) {
    return Math.floor(Math.random() * endExclusive);
}
function $10c0da8dfb629bed$export$264f7bbef4fe8370(...values) {
    return values[$10c0da8dfb629bed$export$3c5f89dae98e900b(values.length)];
}
function $10c0da8dfb629bed$export$1894f1ed2b62f599(array) {
    return array[$10c0da8dfb629bed$export$3c5f89dae98e900b(array.length)];
}
function $10c0da8dfb629bed$export$b3b584c8d6ffe165() {
    return Math.random() >= 0.5;
}
function $10c0da8dfb629bed$export$5da6d711ed0fd711(a, from, to) {
    const x = a[from];
    a[from] = a[to];
    a[to] = x;
}
function $10c0da8dfb629bed$export$7ac3a88d34a76e7(a) {
    for(let i = a.length; i; i--){
        let j = Math.floor(Math.random() * i);
        $10c0da8dfb629bed$export$5da6d711ed0fd711(a, i - 1, j);
    }
}
function $10c0da8dfb629bed$export$b94583dc679500d(textJq, heightMinSpace) {
    textJq.fitText({
        minFontSize: '12px',
        maxFontSize: '35px',
        heightMinSpace: heightMinSpace
    });
}
function $10c0da8dfb629bed$var$fitContentImageIfNeeded(jqimg) {
    jqimg.fitImage({
        show: true
    });
}
function $10c0da8dfb629bed$var$fitContentTextIfNeeded(jqp) {
    if (jqp.is(':visible')) $10c0da8dfb629bed$export$b94583dc679500d(jqp);
}
function $10c0da8dfb629bed$export$2f0b47b0911ce698(container) {
    $10c0da8dfb629bed$var$fitContentImageIfNeeded(container.find('img[fitimage]'));
    $10c0da8dfb629bed$var$fitContentImageIfNeeded(container.find('img[data-fitimage]'));
    $10c0da8dfb629bed$var$fitContentTextIfNeeded(container.find('p[fittext], div[fittext]'));
    $10c0da8dfb629bed$var$fitContentTextIfNeeded(container.find('p[data-fittext], div[data-fittext]'));
}
const $10c0da8dfb629bed$var$TRIM_WHITESPACE = /\s+/g;
const $10c0da8dfb629bed$var$TRIM_PUNCTUATION = /[\u2000-\u206F\u2E00-\u2E7F\\'!"#$%&()*+,\-.\/:;<=>?@\[\]^_`{|}~]/g;
function $10c0da8dfb629bed$var$simplifyForComparison(text) {
    return text.replace($10c0da8dfb629bed$var$TRIM_WHITESPACE, '').replace($10c0da8dfb629bed$var$TRIM_PUNCTUATION, '').toLocaleLowerCase();
}
function $10c0da8dfb629bed$export$6a06ec76c9af6d6c(expected, userText, onlyFullMatch = false) {
    expected = expected.toLocaleLowerCase();
    userText = userText.toLocaleLowerCase();
    // проверяем полное совпадение
    const fullMatch = $10c0da8dfb629bed$var$simplifyForComparison(userText) === $10c0da8dfb629bed$var$simplifyForComparison(expected);
    if (onlyFullMatch || fullMatch) return fullMatch;
    const partsDelimiter = /[,/;]/;
    const expectedParts = expected.split(partsDelimiter).map((item)=>$10c0da8dfb629bed$var$simplifyForComparison(item)).filter((item)=>item.length > 0);
    const userTextParts = userText.split(partsDelimiter).map((item)=>$10c0da8dfb629bed$var$simplifyForComparison(item)).filter((item)=>item.length > 0);
    const expectedPartsFound = expectedParts.filter((userTextPart)=>{
        return userTextParts.some((expectedPart)=>expectedPart === userTextPart);
    });
    if (onlyFullMatch) return expectedPartsFound.length === expectedParts.length;
    return expectedPartsFound.length > 0;
}
function $10c0da8dfb629bed$export$3fb54149990fb5b5(text) {
    switch(String(text)){
        case 'true':
            return true;
        case 'false':
            return false;
        default:
            return null;
    }
}
function $10c0da8dfb629bed$export$53a0910f038337bd(el) {
    $jR4nF((0, (/*@__PURE__*/$parcel$interopDefault($hzVqu)))(el).get(0), {
        time: 1000,
        align: {
            top: 0.1
        },
        ease: function(value) {
            return 1 - Math.pow(1 - value, value / 5);
        }
    });
}
function $10c0da8dfb629bed$export$edd1eb89fbbc58a4(e) {
    return e.which === 13 || e.keyCode === 13;
}
function $10c0da8dfb629bed$export$27297757fabc3b9(e) {
    return e.which === 27 || e.keyCode === 27;
}
function $10c0da8dfb629bed$export$bc733b0c5cbb3e8a(epochSeconds, texter) {
    if (epochSeconds) {
        const diff = epochSeconds - new Date().getTime() / 1000;
        if (diff <= 0) return null;
        const days = diff / $10c0da8dfb629bed$var$DAY_SECONDS;
        if (days > $10c0da8dfb629bed$var$MONTH_DAYS) {
            const months = days / $10c0da8dfb629bed$var$MONTH_DAYS;
            return (0, $3wPZM.Numbers).toMaxDecimals(months, 1) + texter.get('packMemo.short.months');
        }
        if (days > 1) return (0, $3wPZM.Numbers).toMaxDecimals(days, 1) + texter.get('packMemo.short.days');
        const hours = diff / $10c0da8dfb629bed$var$HOUR_SECONDS;
        return (0, $3wPZM.Numbers).toMaxDecimals(hours, 1) + texter.get('packMemo.short.hours');
    }
    return null;
}
function $10c0da8dfb629bed$export$f263d6a9befe8e4a(epochSeconds, texter) {
    if (epochSeconds) {
        const diff = epochSeconds - new Date().getTime() / 1000;
        if (diff <= 0) return null;
        const days = Math.ceil(diff / $10c0da8dfb629bed$var$DAY_SECONDS);
        return texter.get('pl.days', days);
    }
    return null;
}
function $10c0da8dfb629bed$export$9347ed982e2a7713(jqEl) {
    if (jqEl.length) jqEl.focus().click();
}
function $10c0da8dfb629bed$export$19d86ed52b89834e(callback) {
    setTimeout(callback, 1);
}
let $10c0da8dfb629bed$var$USER_TZ = null;
function $10c0da8dfb629bed$export$f2979946b6aa2c7b() {
    if ($10c0da8dfb629bed$var$USER_TZ == null && 'Intl' in window && 'DateTimeFormat' in Intl) {
        const formatter = new Intl.DateTimeFormat();
        if ('resolvedOptions' in formatter) {
            const options = formatter.resolvedOptions();
            if ('timeZone' in options) $10c0da8dfb629bed$var$USER_TZ = options.timeZone;
        }
    }
    return $10c0da8dfb629bed$var$USER_TZ;
}
function $10c0da8dfb629bed$export$bdf91b169a64e21c(cardText, cardTextType) {
    if (cardTextType === 'html') cardText = cardText.replace(/<\/p>/g, '\n').replace(/<[^>]+>/g, '');
    return cardText;
}

});
parcelRegister("lUnw9", function(module, exports) {

$parcel$export(module.exports, "jQuery", () => $ff311208bcc4bcd7$export$1ea89ccd920d3a7, (v) => $ff311208bcc4bcd7$export$1ea89ccd920d3a7 = v);
/*global jQuery */ /*!
* Based on FitText.js 1.2
*
* Copyright 2011, Dave Rupert http://daverupert.com
* Released under the WTFPL license
* http://sam.zoy.org/wtfpl/
*
* Date: Thu May 05 14:23:00 2011 -0600
*/ (function($) {
    function Dim(size, units) {
        this.size = size;
        this.units = units;
    }
    Dim.prototype = {
        multiply: function(k) {
            return new Dim(this.size * k, this.units);
        },
        plus: function(size) {
            return new Dim(this.size + size, this.units);
        },
        toString: function() {
            return '' + this.size + this.units;
        }
    };
    var parseDimRe = /([\d.]+)([\w]*)/;
    function parseDim(val) {
        var match = parseDimRe.exec(val);
        if (match) return new Dim(parseFloat(match[1]), match[2]);
        else return null;
    }
    // Resizer() resizes items based on the object width divided by the compressor * 10
    function fitText(el, parent, settings) {
        el.css('font-size', '');
        var h = el.outerHeight();
        var ph = parent.height();
        if (ph >= h) return;
        // need calculation
        var fontSize = parseDim(el.css('font-size'));
        if (fontSize === null) // cannot workout this font size
        return;
        function changeDirection() {
            if (h > ph) return -1;
            if (h / ph < settings.heightMinSpace) return 1;
            return 0;
        }
        var changeLimit = 10, changeSize = fontSize, change = fontSize.size, directionPrev = 0, direction = changeDirection();
        do {
            if (direction !== directionPrev) change /= 1.7;
            changeSize = changeSize.plus(change * direction);
            el.css('font-size', changeSize.toString());
            h = el.outerHeight();
            directionPrev = direction;
        }while (--changeLimit > 0 && (direction = changeDirection()) !== 0);
        // если мы шли вверх последний раз, то уменьшимся на полшага, на случай, если перескочили границу
        if (direction > 0) {
            changeSize = changeSize.plus(-change);
            el.css('font-size', changeSize.toString());
        }
    // $this.css('font-size', Math.max(Math.min($this.width() / (compressor * 10), parseFloat(settings.maxFontSize)), parseFloat(settings.minFontSize)));
    }
    $.fn.fitText = function(options) {
        // Setup options
        var settings = $.extend({
            minFontSize: Number.NEGATIVE_INFINITY,
            maxFontSize: Number.POSITIVE_INFINITY,
            heightMinSpace: .9
        }, options);
        return this.each(function() {
            // Store the object
            var el = $(this), parent = el.parent();
            // Call once to set.
            fitText(el, parent, settings);
        });
    };
    function fitImage(el, parent, settings) {
        var w = el.width(), pw = parent.width();
        if (w <= 0) return;
        var h = el.height(), ph = parent.height();
        if (h <= 0) return;
        var ratioW = pw / w;
        var ratioH = ph / h;
        var style = {};
        if (ratioW <= ratioH) {
            style.width = '100%';
            style.height = 'auto';
            if (settings.relativePosition) {
                style.top = 100.0 * (ph - h * ratioW) / ph / 2 + '%';
                style.position = 'relative';
            }
        } else {
            style.height = '100%';
            style.width = 'auto';
            if (settings.relativePosition) style.top = 0;
        }
        el.css(style);
        if (settings.show) el.show();
    }
    $.fn.fitImage = function(options) {
        // Setup options
        var settings = $.extend({
            heightMinSpace: .8,
            relativePosition: true,
            show: false
        }, options);
        return this.each(function() {
            // Store the object
            var el = $(this), parent = el.parent();
            var elSrc = this.src;
            if (!elSrc) return;
            el.one("load", function() {
                fitImage(el, parent, settings);
            }).each(function() {
                if (this.complete) $(this).trigger('load');
            });
        });
    };
})(jQuery || $ff311208bcc4bcd7$export$1ea89ccd920d3a7 || window.jQuery);

});

parcelRegister("3wPZM", function(module, exports) {

$parcel$export(module.exports, "Numbers", () => $e7f268f27e8b027c$export$bc00d4d99d9c6e7d);
function $e7f268f27e8b027c$var$nn(v) {
    return v !== null && v !== undefined;
}
const $e7f268f27e8b027c$var$supportsLocaleOptions = !!(typeof Intl === 'object' && Intl && typeof Intl.NumberFormat === 'function');
let $e7f268f27e8b027c$var$_locale = undefined;
function $e7f268f27e8b027c$var$numberLocale() {
    // const _locale = Cookies.get('_locale') || undefined;
    return $e7f268f27e8b027c$var$_locale;
}
function $e7f268f27e8b027c$var$_toLocaleString(val) {
    if ($e7f268f27e8b027c$var$supportsLocaleOptions) return val.toLocaleString($e7f268f27e8b027c$var$numberLocale());
    return val.toLocaleString();
}
function $e7f268f27e8b027c$var$_toLocaleStringWithDecimalPlaces(val, minDecimalPlaces, maxDecimalPlaces) {
    if ($e7f268f27e8b027c$var$supportsLocaleOptions) {
        if (minDecimalPlaces) minDecimalPlaces = Math.min(minDecimalPlaces, 20);
        if (minDecimalPlaces) maxDecimalPlaces = Math.min(maxDecimalPlaces, 20);
        return val.toLocaleString($e7f268f27e8b027c$var$numberLocale(), {
            minimumFractionDigits: minDecimalPlaces,
            maximumFractionDigits: maxDecimalPlaces
        });
    }
    return val.toFixed(maxDecimalPlaces);
}
function $e7f268f27e8b027c$var$toLocaleString(value, options) {
    const num = Number(value);
    if (isNaN(num)) return value;
    const minDecimalPlaces = options && options.minDecimalPlaces;
    const maxDecimalPlaces = options && options.maxDecimalPlaces;
    if (minDecimalPlaces === undefined || maxDecimalPlaces === undefined) return $e7f268f27e8b027c$var$_toLocaleString(num);
    return $e7f268f27e8b027c$var$_toLocaleStringWithDecimalPlaces(num, minDecimalPlaces, maxDecimalPlaces);
}
function $e7f268f27e8b027c$var$isNumber(n) {
    return n !== null && typeof n === 'number' && !isNaN(n);
}
const $e7f268f27e8b027c$var$expPattern = new RegExp(/(\d+)\.?(\d*)e([+-]*)(\d+)/i);
const $e7f268f27e8b027c$var$fixedPattern = new RegExp(/\d+\.?(\d*)/i);
class $e7f268f27e8b027c$export$bc00d4d99d9c6e7d {
    static toLocaleString(value, options) {
        return $e7f268f27e8b027c$var$toLocaleString(value, options);
    }
    static toFixed(n) {
        const precision = $e7f268f27e8b027c$export$bc00d4d99d9c6e7d.getPrecision(n);
        if (precision === null) return null;
        let toLocaleStringOpts = undefined;
        if (precision > 0) toLocaleStringOpts = {
            minDecimalPlaces: precision,
            maxDecimalPlaces: precision
        };
        return $e7f268f27e8b027c$var$toLocaleString(n, toLocaleStringOpts);
    }
    static toPrecision(n, precision) {
        if (!$e7f268f27e8b027c$var$isNumber(n)) return '';
        return $e7f268f27e8b027c$export$bc00d4d99d9c6e7d.toFixed(Number.parseFloat(n.toPrecision(precision)));
    }
    static isNumber(n) {
        return $e7f268f27e8b027c$var$isNumber(n);
    }
    static toPerc2(value) {
        if ($e7f268f27e8b027c$var$isNumber(value)) return $e7f268f27e8b027c$var$toLocaleString(value * 100, {
            minDecimalPlaces: 2,
            maxDecimalPlaces: 2
        }) + '%';
        return '';
    }
    static toInt(value) {
        if ($e7f268f27e8b027c$var$isNumber(value)) return $e7f268f27e8b027c$var$toLocaleString(Math.round(value));
        return '';
    }
    static toDecimals(value, decimals) {
        if (!decimals) decimals = 2;
        const toLocaleStringOpts = {
            minDecimalPlaces: decimals,
            maxDecimalPlaces: decimals
        };
        return $e7f268f27e8b027c$var$toLocaleString(value, toLocaleStringOpts);
    }
    static toMaxDecimals(value, decimals) {
        const toLocaleStringOpts = {
            minDecimalPlaces: 0,
            maxDecimalPlaces: decimals
        };
        return $e7f268f27e8b027c$var$toLocaleString(value, toLocaleStringOpts);
    }
    static getPrecision(n) {
        if (!$e7f268f27e8b027c$var$nn(n)) return null;
        if (typeof n === 'string') n = parseFloat(n);
        if (!$e7f268f27e8b027c$var$isNumber(n)) return null;
        let str = n.toString();
        // https://gist.github.com/jiggzson/b5f489af9ad931e3d186
        const expMatch = $e7f268f27e8b027c$var$expPattern.exec(str);
        if (expMatch) {
            const coefficientFractionDigits = expMatch[2] !== null ? expMatch[2].length : 0;
            const mantissaFractionCorrection = (expMatch[3] === '-' ? -1 : 1) * parseInt(expMatch[4]);
            return coefficientFractionDigits - mantissaFractionCorrection;
        }
        const fixedMatch = $e7f268f27e8b027c$var$fixedPattern.exec(str);
        if (fixedMatch) return fixedMatch[1] !== null ? fixedMatch[1].length : 0;
        return 0;
    }
    static useLocale(locale) {
        $e7f268f27e8b027c$var$_locale = locale;
    }
}

});

parcelRegister("jR4nF", function(module, exports) {
var $e7465d7d1d7be601$var$COMPLETE = 'complete', $e7465d7d1d7be601$var$CANCELED = 'canceled';
function $e7465d7d1d7be601$var$raf(task) {
    if ('requestAnimationFrame' in window) return window.requestAnimationFrame(task);
    setTimeout(task, 16);
}
function $e7465d7d1d7be601$var$setElementScroll(element, x, y) {
    if (element.self === element) element.scrollTo(x, y);
    else {
        element.scrollLeft = x;
        element.scrollTop = y;
    }
}
function $e7465d7d1d7be601$var$getTargetScrollLocation(scrollSettings, parent) {
    var align = scrollSettings.align, target = scrollSettings.target, targetPosition = target.getBoundingClientRect(), parentPosition, x, y, differenceX, differenceY, targetWidth, targetHeight, leftAlign = align && align.left != null ? align.left : 0.5, topAlign = align && align.top != null ? align.top : 0.5, leftOffset = align && align.leftOffset != null ? align.leftOffset : 0, topOffset = align && align.topOffset != null ? align.topOffset : 0, leftScalar = leftAlign, topScalar = topAlign;
    if (scrollSettings.isWindow(parent)) {
        targetWidth = Math.min(targetPosition.width, parent.innerWidth);
        targetHeight = Math.min(targetPosition.height, parent.innerHeight);
        x = targetPosition.left + parent.pageXOffset - parent.innerWidth * leftScalar + targetWidth * leftScalar;
        y = targetPosition.top + parent.pageYOffset - parent.innerHeight * topScalar + targetHeight * topScalar;
        x -= leftOffset;
        y -= topOffset;
        x = scrollSettings.align.lockX ? parent.pageXOffset : x;
        y = scrollSettings.align.lockY ? parent.pageYOffset : y;
        differenceX = x - parent.pageXOffset;
        differenceY = y - parent.pageYOffset;
    } else {
        targetWidth = targetPosition.width;
        targetHeight = targetPosition.height;
        parentPosition = parent.getBoundingClientRect();
        var offsetLeft = targetPosition.left - (parentPosition.left - parent.scrollLeft);
        var offsetTop = targetPosition.top - (parentPosition.top - parent.scrollTop);
        x = offsetLeft + targetWidth * leftScalar - parent.clientWidth * leftScalar;
        y = offsetTop + targetHeight * topScalar - parent.clientHeight * topScalar;
        x -= leftOffset;
        y -= topOffset;
        x = Math.max(Math.min(x, parent.scrollWidth - parent.clientWidth), 0);
        y = Math.max(Math.min(y, parent.scrollHeight - parent.clientHeight), 0);
        x = scrollSettings.align.lockX ? parent.scrollLeft : x;
        y = scrollSettings.align.lockY ? parent.scrollTop : y;
        differenceX = x - parent.scrollLeft;
        differenceY = y - parent.scrollTop;
    }
    return {
        x: x,
        y: y,
        differenceX: differenceX,
        differenceY: differenceY
    };
}
function $e7465d7d1d7be601$var$animate(parent) {
    var scrollSettings = parent._scrollSettings;
    if (!scrollSettings) return;
    var maxSynchronousAlignments = scrollSettings.maxSynchronousAlignments;
    var location = $e7465d7d1d7be601$var$getTargetScrollLocation(scrollSettings, parent), time = Date.now() - scrollSettings.startTime, timeValue = Math.min(1 / scrollSettings.time * time, 1);
    if (scrollSettings.endIterations >= maxSynchronousAlignments) {
        $e7465d7d1d7be601$var$setElementScroll(parent, location.x, location.y);
        parent._scrollSettings = null;
        return scrollSettings.end($e7465d7d1d7be601$var$COMPLETE);
    }
    var easeValue = 1 - scrollSettings.ease(timeValue);
    $e7465d7d1d7be601$var$setElementScroll(parent, location.x - location.differenceX * easeValue, location.y - location.differenceY * easeValue);
    if (time >= scrollSettings.time) {
        scrollSettings.endIterations++;
        // Align ancestor synchronously
        scrollSettings.scrollAncestor && $e7465d7d1d7be601$var$animate(scrollSettings.scrollAncestor);
        $e7465d7d1d7be601$var$animate(parent);
        return;
    }
    $e7465d7d1d7be601$var$raf($e7465d7d1d7be601$var$animate.bind(null, parent));
}
function $e7465d7d1d7be601$var$defaultIsWindow(target) {
    return target.self === target;
}
function $e7465d7d1d7be601$var$transitionScrollTo(target, parent, settings, scrollAncestor, callback) {
    var idle = !parent._scrollSettings, lastSettings = parent._scrollSettings, now = Date.now(), cancelHandler, passiveOptions = {
        passive: true
    };
    if (lastSettings) lastSettings.end($e7465d7d1d7be601$var$CANCELED);
    function end(endType) {
        parent._scrollSettings = null;
        if (parent.parentElement && parent.parentElement._scrollSettings) parent.parentElement._scrollSettings.end(endType);
        if (settings.debug) console.log('Scrolling ended with type', endType, 'for', parent);
        callback(endType);
        if (cancelHandler) {
            parent.removeEventListener('touchstart', cancelHandler, passiveOptions);
            parent.removeEventListener('wheel', cancelHandler, passiveOptions);
        }
    }
    var maxSynchronousAlignments = settings.maxSynchronousAlignments;
    if (maxSynchronousAlignments == null) maxSynchronousAlignments = 3;
    parent._scrollSettings = {
        startTime: now,
        endIterations: 0,
        target: target,
        time: settings.time,
        ease: settings.ease,
        align: settings.align,
        isWindow: settings.isWindow || $e7465d7d1d7be601$var$defaultIsWindow,
        maxSynchronousAlignments: maxSynchronousAlignments,
        end: end,
        scrollAncestor: scrollAncestor
    };
    if (!('cancellable' in settings) || settings.cancellable) {
        cancelHandler = end.bind(null, $e7465d7d1d7be601$var$CANCELED);
        parent.addEventListener('touchstart', cancelHandler, passiveOptions);
        parent.addEventListener('wheel', cancelHandler, passiveOptions);
    }
    if (idle) $e7465d7d1d7be601$var$animate(parent);
    return cancelHandler;
}
function $e7465d7d1d7be601$var$defaultIsScrollable(element) {
    return 'pageXOffset' in element || (element.scrollHeight !== element.clientHeight || element.scrollWidth !== element.clientWidth) && getComputedStyle(element).overflow !== 'hidden';
}
function $e7465d7d1d7be601$var$defaultValidTarget() {
    return true;
}
function $e7465d7d1d7be601$var$findParentElement(el) {
    if (el.assignedSlot) return $e7465d7d1d7be601$var$findParentElement(el.assignedSlot);
    if (el.parentElement) {
        if (el.parentElement.tagName.toLowerCase() === 'body') return el.parentElement.ownerDocument.defaultView || el.parentElement.ownerDocument.ownerWindow;
        return el.parentElement;
    }
    if (el.getRootNode) {
        var parent = el.getRootNode();
        if (parent.nodeType === 11) return parent.host;
    }
}
module.exports = function(target, settings, callback) {
    if (!target) return;
    if (typeof settings === 'function') {
        callback = settings;
        settings = null;
    }
    if (!settings) settings = {};
    settings.time = isNaN(settings.time) ? 1000 : settings.time;
    settings.ease = settings.ease || function(v) {
        return 1 - Math.pow(1 - v, v / 2);
    };
    settings.align = settings.align || {};
    var parent = $e7465d7d1d7be601$var$findParentElement(target), parents = 1;
    function done(endType) {
        parents--;
        if (!parents) callback && callback(endType);
    }
    var validTarget = settings.validTarget || $e7465d7d1d7be601$var$defaultValidTarget;
    var isScrollable = settings.isScrollable;
    if (settings.debug) {
        console.log('About to scroll to', target);
        if (!parent) console.error('Target did not have a parent, is it mounted in the DOM?');
    }
    var scrollingElements = [];
    while(parent){
        if (settings.debug) console.log('Scrolling parent node', parent);
        if (validTarget(parent, parents) && (isScrollable ? isScrollable(parent, $e7465d7d1d7be601$var$defaultIsScrollable) : $e7465d7d1d7be601$var$defaultIsScrollable(parent))) {
            parents++;
            scrollingElements.push(parent);
        }
        parent = $e7465d7d1d7be601$var$findParentElement(parent);
        if (!parent) {
            done($e7465d7d1d7be601$var$COMPLETE);
            break;
        }
    }
    return scrollingElements.reduce((cancel, parent, index)=>$e7465d7d1d7be601$var$transitionScrollTo(target, parent, settings, scrollingElements[index + 1], done), null);
};

});


parcelRegister("6YELt", function(module, exports) {

$parcel$export(module.exports, "default", () => $20b53f3acbb2f106$export$2e2bcd8739ae039);
const $20b53f3acbb2f106$var$END_FE = '}';
const $20b53f3acbb2f106$var$START_FE = '{';
const $20b53f3acbb2f106$var$QUOTE = "'";
class $20b53f3acbb2f106$var$StringReader {
    constructor(input){
        this.input = input || '';
        this.index = 0;
    }
    advance() {
        if (this.hasMore()) this.index++;
    }
    /**
     * @param {RegExp} test
     * @returns {boolean}
     */ expectNextR(test) {
        if (this.index >= this.input.length - 1) return false;
        return test.test(this.input.charAt(this.index + 1));
    }
    /**
     * @param {String} test
     * @returns {boolean}
     */ expectNext(test) {
        if (this.index >= this.input.length - 1) return false;
        return test === this.input.charAt(this.index + 1);
    }
    hasMore() {
        return this.index < this.input.length;
    }
    getChar() {
        return this.input.charAt(this.index);
    }
    /**
     * @param re
     * @returns string
     */ readWhileR(re) {
        let result = '';
        while(this.hasMore()){
            if (!re.test(this.getChar())) break;
            result += this.getChar();
            this.advance();
        }
        return result;
    }
    /**
     * @param {RegExp} re
     * @returns string
     */ readUnlessR(re) {
        let result = '';
        while(this.hasMore()){
            const next = this.getChar();
            if (re.test(next)) break;
            result += next;
            this.advance();
        }
        return result;
    }
    /**
     * @param {String} re
     * @returns string
     */ readUnless(re) {
        let result = '';
        while(this.hasMore()){
            const next = this.getChar();
            if (re === next) break;
            result += next;
            this.advance();
        }
        return result;
    }
    /**
     * @param re
     * @returns string
     */ skipWhileR(re) {
        while(this.hasMore()){
            if (!re.test(this.getChar())) break;
            this.advance();
        }
    }
    getRest() {
        return this.input.substring(this.index);
    }
    /**
     * @param {Function} contentTest
     * @param {Boolean} keepQuotedString set true, if your want original quoted string, without unescape
     * @returns {String}
     */ readBraces(contentTest, keepQuotedString) {
        let mark = this.index;
        if (typeof contentTest !== 'function') contentTest = ()=>true;
        if (typeof keepQuotedString === "undefined") keepQuotedString = false;
        let content = '';
        let deep = 1;
        this.advance();
        const fail = ()=>{
            this.index = mark;
            return null;
        };
        while(this.hasMore()){
            switch(this.getChar()){
                case $20b53f3acbb2f106$var$QUOTE:
                    const quotedString = this.readQuoted();
                    content += keepQuotedString ? quotedString.raw : quotedString.value;
                    continue;
                case $20b53f3acbb2f106$var$START_FE:
                    deep++;
                    break;
                case $20b53f3acbb2f106$var$END_FE:
                    if (deep === 1) {
                        if (contentTest(content)) {
                            this.advance();
                            return content;
                        } else return fail();
                    } else deep--;
            }
            content += this.getChar();
            this.advance();
        }
        return fail();
    }
    /**
     * @returns {QuotedString}
     */ readQuoted() {
        let raw = this.getChar();
        this.advance();
        if (this.hasMore() && this.getChar() === $20b53f3acbb2f106$var$QUOTE) {
            raw += this.getChar();
            this.advance();
            return new $20b53f3acbb2f106$var$QuotedString($20b53f3acbb2f106$var$QUOTE, raw);
        }
        let value = '';
        while(this.hasMore()){
            raw += this.getChar();
            if (this.getChar() === $20b53f3acbb2f106$var$QUOTE) {
                this.advance();
                if (this.getChar() === $20b53f3acbb2f106$var$QUOTE) raw += this.getChar();
                else return new $20b53f3acbb2f106$var$QuotedString(value, raw);
            }
            value += this.getChar();
            this.advance();
        }
        return new $20b53f3acbb2f106$var$QuotedString(value, raw);
    }
}
class $20b53f3acbb2f106$var$QuotedString {
    constructor(value, raw){
        this.value = value;
        this.raw = raw;
    }
}
const $20b53f3acbb2f106$var$ICUMessageFormats = {
    'default': (ordinal)=>{
        return (texter, args)=>args[ordinal];
    },
    'plural': (ordinal, options)=>{
        const optionsReader = new $20b53f3acbb2f106$var$StringReader(options);
        const model = {};
        while(optionsReader.hasMore()){
            const state = optionsReader.readUnless($20b53f3acbb2f106$var$START_FE).trim();
            if (state === '') break;
            model[state] = optionsReader.readBraces();
        }
        return (texter, args)=>{
            const argsValue = args[ordinal];
            const number = typeof argsValue === "number" ? Math.floor(argsValue) : parseInt(argsValue);
            let state = null;
            if (!isNaN(number)) state = texter.numberPlural(number);
            if (state in model) return model[state];
            return model['other'];
        };
    }
};
/**
 * Javascript port for com.rico.rubd.support.icu.ICUMessageFormat
 */ class $20b53f3acbb2f106$var$ICUMessageFormat {
    constructor(pattern){
        this.formats = [];
        this.parsePattern(pattern, (token)=>this.formats.push(()=>token), (ordinal, spec, options)=>this.formats.push(this.createFormatter(ordinal, spec, options)));
    }
    /**
     * @param {String} pattern
     * @param {Function} textReceiver
     * @param {Function} formatReceiver
     * @private
     */ parsePattern(pattern, textReceiver, formatReceiver) {
        const reader = new $20b53f3acbb2f106$var$StringReader(pattern);
        let token = '';
        function panic() {
            throw new Error(`invalid pattern ${pattern}`);
        }
        const argumentComplete = (content)=>{
            if (!content.length) return;
            const tokenReader = new $20b53f3acbb2f106$var$StringReader(content);
            tokenReader.skipWhileR(/[\s]/);
            const ordinal = parseInt(tokenReader.readWhileR(/\d+/).trim());
            if (isNaN(ordinal)) panic();
            tokenReader.skipWhileR(/[\s,]/);
            const spec = tokenReader.readUnlessR(/,/).trim();
            tokenReader.skipWhileR(/[\s,]/);
            let options = tokenReader.getRest().trim();
            formatReceiver(ordinal, spec, options);
        };
        const textComplete = (token)=>{
            if (token.length) textReceiver(token);
        };
        const FE_ORDINAL_TEST = /^\s*\d/;
        while(reader.hasMore()){
            switch(reader.getChar()){
                case $20b53f3acbb2f106$var$START_FE:
                    textComplete(token);
                    token = '';
                    const braces = reader.readBraces(FE_ORDINAL_TEST.test.bind(FE_ORDINAL_TEST), true);
                    if (braces == null) break;
                    argumentComplete(braces);
                    continue;
                case $20b53f3acbb2f106$var$QUOTE:
                    token += reader.readQuoted().value;
                    continue;
            }
            token += reader.getChar();
            reader.advance();
        }
        textComplete(token);
    }
    /**
     * @param {int} ordinal parameter index
     * @param {string} spec formatter class
     * @param {string} options other parameters
     * @private
     */ createFormatter(ordinal, spec, options) {
        const factory = spec in $20b53f3acbb2f106$var$ICUMessageFormats ? $20b53f3acbb2f106$var$ICUMessageFormats[spec] : $20b53f3acbb2f106$var$ICUMessageFormats.default;
        return factory(ordinal, options);
    }
    format(texter, args) {
        switch(this.formats.length){
            case 0:
                return '';
            case 1:
                return this.formats[0](texter, args);
            default:
                return this.formats.map((f)=>f(texter, args)).join('');
        }
    }
}
/**
 * https://www.unicode.org/cldr/charts/34/supplemental/language_plural_rules.html
 */ const $20b53f3acbb2f106$var$TexterSpec = {
    defaults: {
        pluralRule: function(n) {
            if (n === 1) return 'one';
            return 'many';
        }
    },
    'ru': {
        pluralRule: function(n) {
            const rem10 = n % 10;
            const rem100 = n % 100;
            if (rem10 === 1 && rem100 !== 11) return 'one';
            if ((rem10 === 2 || rem10 === 3 || rem10 === 4) && rem100 !== 12 && rem100 !== 13 && rem100 !== 14) return 'few';
            return 'many';
        }
    }
};
class $20b53f3acbb2f106$export$2e2bcd8739ae039 {
    static create(l18n) {
        return l18n instanceof $20b53f3acbb2f106$export$2e2bcd8739ae039 ? l18n : new $20b53f3acbb2f106$export$2e2bcd8739ae039(l18n);
    }
    constructor(texts){
        this.texts = texts || [];
        this.cache = {};
        this.locale = 'en';
        let spec = null;
        if ('_language' in this.texts) spec = $20b53f3acbb2f106$var$TexterSpec[this.texts['_language']];
        this.spec = !!spec ? spec : $20b53f3acbb2f106$var$TexterSpec.defaults;
    }
    /**
     * @param key
     * @returns {String}
     * @private
     */ getText(key) {
        return key in this.texts ? this.texts[key] : key;
    }
    /**
     * @param key
     * @returns {ICUMessageFormat}
     * @private
     */ getOrCompileFormatter(key) {
        const cached = this.cache[key];
        if (cached) return cached;
        const pattern = key in this.texts ? this.texts[key] : key;
        return this.cache[key] = new $20b53f3acbb2f106$var$ICUMessageFormat(pattern);
    }
    /**
     * @param key
     * @param args
     * @returns {String}
     */ get(key, ...args) {
        if (args.length === 0) return this.getText(key);
        const formatter = this.getOrCompileFormatter(key);
        return formatter.format(this, args);
    }
    put(key, value) {
        this.texts[key] = value;
    }
    numberPlural(n) {
        return this.spec.pluralRule(n);
    }
}

});

parcelRegister("bO0MK", function(module, exports) {

$parcel$export(module.exports, "default", () => $acc291598054ebf9$export$2e2bcd8739ae039);
class $acc291598054ebf9$export$2e2bcd8739ae039 {
    constructor(parent, l18n, titleTemplate){
        this.l18n = l18n;
        this.parent = parent;
        if (!titleTemplate) titleTemplate = $acc291598054ebf9$export$2e2bcd8739ae039.createTitleTextElement(l18n.get('packPlay.progressBar.title'));
        this.parent.append(`
<div class="fl-progress-bar">
    <div class="fl-progress-bar__title">${titleTemplate}</div>
    <div class="fl-progress-bar__bar">
        <div class="fl-progress-bar__thumb"></div>
    </div>
</div>
        `);
        this._resize();
    }
    /**
     * @param {string} label
     * @param {string} [bindId]
     * @returns {string}
     */ static createTitleTextElement(label, bindId) {
        if (!bindId) bindId = 'message';
        return `
<div class="fl-progress-bar__title-text">
    <span class="fl-progress-bar__title-text-label">${label}</span>
    <span class="fl-progress-bar__title-text-val" data-bind="${bindId}"></span>
</div>
        `;
    }
    setCustomText(bindId, val) {
        this.parent.find(`span[data-bind=${bindId}]`).text(val);
        this._resize();
    }
    set text(val) {
        this.setCustomText('message', val);
        this._resize();
    }
    set percent(val) {
        this.parent.find('.fl-progress-bar__thumb').width(val + '%');
        this._resize();
    }
    _resize() {}
}

});

parcelRegister("9aeLI", function(module, exports) {

$parcel$export(module.exports, "default", () => $7e9dc0dea38c1267$export$2e2bcd8739ae039);

var $hzVqu = parcelRequire("hzVqu");

var $8fkwP = parcelRequire("8fkwP");
const $7e9dc0dea38c1267$var$SOURCE_ATTRIBUTE = 'audio-source';
const $7e9dc0dea38c1267$var$SOURCE_AUDIO = 'audio';
const $7e9dc0dea38c1267$var$SOURCE_SPEECH = 'speech';
// const log = console.log;
const $7e9dc0dea38c1267$var$log = (0, (/*@__PURE__*/$parcel$interopDefault($hzVqu))).noop;
let $7e9dc0dea38c1267$var$RID = 0;
let $7e9dc0dea38c1267$var$STOPPERS = [];
function $7e9dc0dea38c1267$var$noop() {}
function $7e9dc0dea38c1267$var$registerStopper(fn) {
    const rid = ++$7e9dc0dea38c1267$var$RID;
    return {
        enable: function() {
            $7e9dc0dea38c1267$var$STOPPERS[rid] = fn;
        },
        disable: function() {
            delete $7e9dc0dea38c1267$var$STOPPERS[rid];
        }
    };
}
(0, $8fkwP.SpeakerFactory).addReadyCallback(()=>{
    $7e9dc0dea38c1267$var$log('got voices');
});
class $7e9dc0dea38c1267$export$2e2bcd8739ae039 {
    static addReadyCallback(fn) {
        (0, $8fkwP.SpeakerFactory).addReadyCallback(fn);
    }
    static stop() {
        (0, $8fkwP.SpeakerFactory).cancel();
        // stop all started audio
        Object.values($7e9dc0dea38c1267$var$STOPPERS).forEach((fn)=>fn());
        $7e9dc0dea38c1267$var$STOPPERS = [];
    }
    static multiSideButton(buttonElement, ...sides) {
        const controller = new $7e9dc0dea38c1267$var$SoundButtonSequence(buttonElement);
        sides.forEach((side)=>controller.add(side));
        return controller;
    }
    static singleSideButton(buttonElement, side) {
        return new $7e9dc0dea38c1267$var$SoundButtonController(side, new $7e9dc0dea38c1267$var$SoundButtonState(buttonElement));
    }
}
class $7e9dc0dea38c1267$var$SoundButtonState {
    constructor(buttonElement){
        this.button = (0, (/*@__PURE__*/$parcel$interopDefault($hzVqu)))(buttonElement);
    }
    get playing() {
        return this.button.hasClass('text-success');
    }
    set playing(value) {
        this.button.toggleClass('text-success', value);
    }
}
class $7e9dc0dea38c1267$var$SoundButtonController {
    constructor(contentNode, stater){
        this.stater = stater;
        this.node = (0, (/*@__PURE__*/$parcel$interopDefault($hzVqu)))(contentNode);
        this._completer = $7e9dc0dea38c1267$var$noop;
    }
    _resolveSoundSource() {
        let source = this.node.data($7e9dc0dea38c1267$var$SOURCE_ATTRIBUTE);
        if (!source) {
            const ret = (source)=>{
                this.node.data($7e9dc0dea38c1267$var$SOURCE_ATTRIBUTE, source);
                return source;
            };
            // if it's audio from audio tag
            const audioTag = this.node.find('audio');
            if (audioTag.length) {
                const audio = audioTag.get(0);
                const stopper = $7e9dc0dea38c1267$var$registerStopper(()=>{
                    audio.pause();
                });
                audioTag.on('pause', ()=>{
                    stopper.disable();
                    this._invokeCompleter();
                    this.stater.playing = false;
                }).on('play', ()=>{
                    stopper.enable();
                    this.stater.playing = true;
                });
                return ret($7e9dc0dea38c1267$var$SOURCE_AUDIO);
            }
            return ret($7e9dc0dea38c1267$var$SOURCE_SPEECH);
        }
        return source;
    }
    _invokeCompleter() {
        if (this._completer) {
            this._completer();
            this._completer = null;
        }
    }
    _afterStop() {}
    _speechToggle() {
        if (this.stater.playing) $7e9dc0dea38c1267$export$2e2bcd8739ae039.stop();
        else this._speechStart();
    }
    _speechStart() {
        const lang = this.node.data('lang');
        let text = this.node.data('text');
        if (!text) text = this.node.text();
        const speaker = (0, $8fkwP.SpeakerFactory).create(text, lang);
        if (speaker != null) speaker.say(()=>{
            this.stater.playing = true;
        }, ()=>{
            this._invokeCompleter();
            this.stater.playing = false;
        });
    }
    _audioToggle() {
        const audio = this.node.find('audio').get(0);
        if (audio.paused) this._audioStart();
        else audio.pause();
    }
    _audioStart() {
        const audio = this.node.find('audio').get(0);
        audio.currentTime = 0;
        audio.play();
    }
    toggle(completer) {
        this._completer = completer || $7e9dc0dea38c1267$var$noop;
        const source = this._resolveSoundSource();
        switch(source){
            case $7e9dc0dea38c1267$var$SOURCE_AUDIO:
                this._audioToggle();
                break;
            case $7e9dc0dea38c1267$var$SOURCE_SPEECH:
                this._speechToggle();
                break;
        }
    }
    start(completer) {
        this._completer = completer || $7e9dc0dea38c1267$var$noop;
        const source = this._resolveSoundSource();
        switch(source){
            case $7e9dc0dea38c1267$var$SOURCE_AUDIO:
                this._audioStart();
                break;
            case $7e9dc0dea38c1267$var$SOURCE_SPEECH:
                this._speechStart();
                break;
        }
    }
    stop() {
        $7e9dc0dea38c1267$export$2e2bcd8739ae039.stop();
    }
}
class $7e9dc0dea38c1267$var$SoundButtonSequence {
    constructor(buttonElement){
        this.buttonElement = buttonElement;
        this._delegates = [];
        this._next = $7e9dc0dea38c1267$var$noop;
        this._current = null;
        this._stopper = $7e9dc0dea38c1267$var$registerStopper(()=>this.stop());
    }
    get playing() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($hzVqu)))(this.buttonElement).hasClass('text-success');
    }
    set playing(value) {
        (0, (/*@__PURE__*/$parcel$interopDefault($hzVqu)))(this.buttonElement).toggleClass('text-success', value);
        if (!value) this._next();
    }
    add(element) {
        if (!element) return;
        this._delegates.push(element);
    }
    toggle() {
        if (this.playing) this.stop();
        else this.start();
    }
    start() {
        if (this._delegates.length === 0) return;
        this._stopper.enable();
        this._next = ()=>{
            if (this._current == null) return;
            const next = this._current.index + 1;
            if (next < this._delegates.length) this._goTo(next);
            else this.stop();
        };
        this._goTo(0);
    }
    stop() {
        $7e9dc0dea38c1267$var$log('SoundButtonSequence: stop');
        this._next = $7e9dc0dea38c1267$var$noop;
        this._stopper.disable();
        if (this._current) {
            this._current.stop();
            this._current = null;
        }
    }
    _goTo(index) {
        $7e9dc0dea38c1267$var$log(`SoundButtonSequence: say ${index}...`);
        this._current = new $7e9dc0dea38c1267$var$SoundButtonController(this._delegates[index], this);
        this._current.index = index;
        this._current.start();
    }
}

});
parcelRegister("8fkwP", function(module, exports) {

$parcel$export(module.exports, "SpeakerFactory", () => $1a8869fd2907788a$export$5e5b5ae29c785ea);
function $1a8869fd2907788a$var$noop() {}
// const log = console.log;
const $1a8869fd2907788a$var$log = $1a8869fd2907788a$var$noop;
class $1a8869fd2907788a$export$42815fdb13356255 {
    constructor(text, voice){
        this._text = text;
        this._voice = voice;
    }
    say(startCallback, finishCallback) {
        const utterance = new window.SpeechSynthesisUtterance();
        utterance.voice = this._voice;
        utterance.lang = this._voice.lang;
        utterance.text = this._text;
        utterance.volume = 1;
        utterance.pitch = 1;
        utterance.rate = 1;
        utterance.addEventListener('start', function() {
            $1a8869fd2907788a$var$log('Speaker started');
            (startCallback || $1a8869fd2907788a$var$noop)();
        });
        utterance.addEventListener('end', function() {
            $1a8869fd2907788a$var$log('Speaker finished');
            (finishCallback || $1a8869fd2907788a$var$noop)();
        });
        utterance.addEventListener('error', function(event) {
            $1a8869fd2907788a$var$log('An error has occurred with the speech synthesis: ' + event.error);
            (finishCallback || $1a8869fd2907788a$var$noop)();
        });
        const speechSynthesis = window.speechSynthesis;
        speechSynthesis.cancel();
        speechSynthesis.speak(utterance);
    }
}
const $1a8869fd2907788a$var$AVAILABLE = 'speechSynthesis' in window;
let $1a8869fd2907788a$var$VOICES = [];
function $1a8869fd2907788a$var$reloadVoicesIfEmpty() {
    if ($1a8869fd2907788a$var$AVAILABLE && $1a8869fd2907788a$var$VOICES.length === 0) $1a8869fd2907788a$var$VOICES = window.speechSynthesis.getVoices();
}
$1a8869fd2907788a$var$reloadVoicesIfEmpty();
function $1a8869fd2907788a$var$findVoice(langPrefix) {
    const selection = $1a8869fd2907788a$var$VOICES.filter((voice)=>voice.lang.startsWith(langPrefix));
    if (selection.length) return selection[0];
    return null;
}
class $1a8869fd2907788a$export$5e5b5ae29c785ea {
    static get enabled() {
        return $1a8869fd2907788a$var$AVAILABLE && $1a8869fd2907788a$var$VOICES.length > 0;
    }
    /**
     * @param text
     * @param lang
     * @return {object} true if engine is available
     */ static create(text, lang) {
        if (!$1a8869fd2907788a$var$AVAILABLE) return null;
        let voice = null;
        if (voice === null && lang === 'en') voice = $1a8869fd2907788a$var$findVoice(lang + '-US');
        if (voice === null && lang === 'en') voice = $1a8869fd2907788a$var$findVoice(lang + '_US');
        if (voice === null) voice = $1a8869fd2907788a$var$findVoice(lang);
        if (voice === null) voice = $1a8869fd2907788a$var$findVoice('en');
        return voice ? new $1a8869fd2907788a$export$42815fdb13356255(text, voice) : null;
    }
    static cancel() {
        if (!$1a8869fd2907788a$var$AVAILABLE) return;
        window.speechSynthesis.cancel();
    }
    static addReadyCallback(fn) {
        if (!$1a8869fd2907788a$var$AVAILABLE) return;
        if (!fn) fn = $1a8869fd2907788a$var$noop;
        const handler = {
            called: false,
            invoke: function() {
                if (!this.called) {
                    this.called = true;
                    fn();
                }
            }
        };
        $1a8869fd2907788a$var$reloadVoicesIfEmpty();
        if ($1a8869fd2907788a$var$VOICES.length) handler.invoke();
        else window.speechSynthesis.addEventListener('voiceschanged', ()=>{
            $1a8869fd2907788a$var$log('got voices!');
            $1a8869fd2907788a$var$VOICES = window.speechSynthesis.getVoices();
            handler.invoke();
        });
    }
}

});


parcelRegister("fSddt", function(module, exports) {

$parcel$export(module.exports, "default", () => $79981bfdf9e6e950$export$2e2bcd8739ae039);
function $79981bfdf9e6e950$export$2e2bcd8739ae039(mapName, valueSupplier) {
    const storage = {};
    if (!mapName) mapName = 'mkey';
    return {
        get (el) {
            let mapKey = $(el).data(mapName);
            if (!mapKey) {
                mapKey = mapName + '-' + new Date().getTime() + '-' + Math.random();
                $(el).data(mapName, mapKey);
            }
            let mapValue = storage[mapKey];
            if (!mapValue) {
                mapValue = valueSupplier(el);
                storage[mapKey] = mapValue;
            }
            return mapValue;
        }
    };
}

});

parcelRegister("iwyex", function(module, exports) {

$parcel$export(module.exports, "default", () => $d0321ed30b5174e7$export$2e2bcd8739ae039);
function $d0321ed30b5174e7$export$2e2bcd8739ae039(e) {
    if ('stopImmediatePropagation' in e) e.stopImmediatePropagation();
    if ('preventDefault' in e) e.preventDefault();
    if ('stopPropagation' in e) e.stopPropagation();
    return false;
}

});


var $hzVqu = parcelRequire("hzVqu");
parcelRequire("du6ua");

var $3zknA = parcelRequire("3zknA");

var $6YELt = parcelRequire("6YELt");

var $bO0MK = parcelRequire("bO0MK");

var $9aeLI = parcelRequire("9aeLI");

var $fSddt = parcelRequire("fSddt");

var $iwyex = parcelRequire("iwyex");
// const log = console.log;
const $8ee82b35ce3d87b9$var$log = (0, (/*@__PURE__*/$parcel$interopDefault($hzVqu))).noop;
class $8ee82b35ce3d87b9$var$PackPlay {
    constructor(opts){
        const l18n = (0, $6YELt.default).create(opts.l18n);
        const playList = opts.playList;
        const playProgressBar = new (0, $bO0MK.default)(opts.playProgress, l18n);
        this.playControls = opts.playControls;
        this.views = playList.find('.play-card-stack__card');
        const modeChanged = (mode)=>{
            (0, (/*@__PURE__*/$parcel$interopDefault($hzVqu)))('#playTurn').prop('disabled', mode === 'both');
            this.playControls.find('[data-click=showBoth]').toggleClass('active', mode === 'both').attr('aria-pressed', mode === 'both');
            playList.toggleClass('play-card-stack--both-faces', mode === 'both');
        };
        const progresser = (progress)=>{
            const currentNumber = this.currentIndex + 1;
            var percent = progress.total > 0 ? currentNumber / progress.total : 1;
            playProgressBar.text = `${currentNumber} / ${progress.total}`;
            playProgressBar.percent = percent * 100;
            this.playControls.find('[data-bind=playIndex]').text(l18n.get('packPlay.progressTemplate').replace(/\{0\}/g, currentNumber).replace(/\{1\}/g, progress.total));
        };
        this.currentList = [];
        this.currentIndex = -1;
        this.currentView = null;
        this.currentSide = '';
        this.displayMode = 'side';
        this.displayModeChanged = ()=>{
            modeChanged(this.displayMode);
            if (this.currentView !== null) this._fitSideText((0, (/*@__PURE__*/$parcel$interopDefault($hzVqu)))(this.currentView));
        };
        this.cardOutAnim = 'fadeOutUp';
        (0, $9aeLI.default).addReadyCallback(()=>{
            playList.addClass('play-card-stack--speakable');
        });
        const audioSupplier = (button)=>(0, $9aeLI.default).singleSideButton(button, (0, (/*@__PURE__*/$parcel$interopDefault($hzVqu)))(button).closest('.play-card-stack__card-side'));
        const audioCache = (0, $fSddt.default)('audio-cache', audioSupplier);
        playList.on('click', 'button[data-click=sayText]', (e)=>{
            audioCache.get(e.currentTarget).toggle();
            return (0, $iwyex.default)(e);
        });
        playList.on('click', '.play-card-stack__card-face', (e)=>{
            this._onCardClick();
            return false;
        });
        playList.on('click', '.play-card-stack__card-back', (e)=>{
            this._onCardClick();
            return false;
        });
        this.progresser = (0, (/*@__PURE__*/$parcel$interopDefault($hzVqu))).isFunction(progresser) ? progresser : (0, (/*@__PURE__*/$parcel$interopDefault($hzVqu))).noop;
        this.progress = {
            total: this.views.length,
            passed: 0,
            increment: function() {
                this.passed += 1;
                if (this.passed > this.total) this.passed = 1;
            }
        };
        this.displayModeChanged();
        function bindShortcut(button, key, func) {
            (0, (/*@__PURE__*/$parcel$interopDefault($hzVqu)))(document).on('keypress', null, key, func);
            (0, (/*@__PURE__*/$parcel$interopDefault($hzVqu)))(button).click(func);
        }
        bindShortcut(this.playControls.find('[data-click=playPrev]'), "p \u0437", this.prev.bind(this));
        bindShortcut(this.playControls.find('[data-click=playNext]'), "n \u0442", this.next.bind(this));
        bindShortcut('#playTurn', "f \u0430", this.turn.bind(this));
        bindShortcut(this.playControls.find('[data-click=playShuffle]'), "s \u044B", this.shuffle.bind(this));
        bindShortcut(this.playControls.find('[data-click=showBoth]'), "b \u0438", this.toggleBoth.bind(this));
    }
    _shuffle() {
        let lastLast = null;
        if (this.currentList.length > 0) lastLast = this.currentList[this.currentList.length - 1];
        this.currentList = [];
        for(let i = 0; i < this.views.length; ++i)this.currentList.push(this.views.get(i));
        (0, $3zknA.shuffleArray)(this.currentList);
        if (lastLast !== null && this.currentList.length > 0 && lastLast === this.currentList[0]) (0, $3zknA.swapInArray)(this.currentList, 0, this.currentList.length - 1);
    }
    stopSpeak() {
        (0, $9aeLI.default).stop();
    }
    start() {
        this.stopSpeak();
        this.progress.passed = 0;
        this._currentViewDiscard();
        this._display(this._next());
        this._fireProgress();
    }
    next() {
        this.stopSpeak();
        if (this._isBothDisplayMode()) this._display(this._next());
        else if (this.currentSide === 'front') {
            this._displayFace(false);
            this._displayBack(true);
        } else this._display(this._next());
    }
    turn() {
        if (this._isBothDisplayMode()) return;
        this.stopSpeak();
        if (this.currentSide === 'back') {
            this._displayBack(false);
            this._displayFace(true);
        } else {
            this._displayFace(false);
            this._displayBack(true);
        }
    }
    prev() {
        this.stopSpeak();
        if (this._isBothDisplayMode()) this._display(this._prev());
        else if (this.currentSide === 'back') {
            this._displayFace(true);
            this._displayBack(false);
        } else this._display(this._prev());
    }
    _prev() {
        this.currentIndex = (this.currentIndex - 1 + this.views.length) % this.views.length;
        if (this.currentIndex === this.views.length - 1) this._shuffle();
        return this.currentList[this.currentIndex];
    }
    _next() {
        this.currentIndex = (this.currentIndex + 1) % this.views.length;
        if (this.currentIndex === 0) this._shuffle();
        return this.currentList[this.currentIndex];
    }
    _needHideAnimation(view) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($hzVqu)))(view).css('position') === 'absolute';
    }
    _needFitText(view) {
        // return $(view).css('position') === 'absolute';
        return true;
    }
    _currentViewDiscard() {
        if (this.currentView === null) return;
        const last = (0, (/*@__PURE__*/$parcel$interopDefault($hzVqu)))(this.currentView);
        const hider = function() {
            last.hide();
        };
        if (this._needHideAnimation(last)) last.animateCss(this.cardOutAnim, hider);
        else hider();
        this.currentView = null;
    }
    _display(view) {
        if (this.currentView === view) {
            this._displayFace(true);
            this._displayBack(this._isBothDisplayMode());
            return;
        }
        this._currentViewDiscard();
        if (view !== null) {
            this.currentView = view;
            const current = (0, (/*@__PURE__*/$parcel$interopDefault($hzVqu)))(view);
            current.show();
            current.animateCssStop(this.cardOutAnim);
            this._displayFace(true);
            this._displayBack(this._isBothDisplayMode());
            this.progress.increment();
            this._fireProgress();
        }
    }
    _onCardClick() {
        this.next();
    }
    _fitSideText(side) {
        if (this._needFitText(this.currentView)) (0, $3zknA.fitText)(side.find('.play-card-stack__card-text > div'), .7);
        side.find('.play-card-stack__card-image > img').fitImage();
    }
    _displayFace(visible) {
        const side = (0, (/*@__PURE__*/$parcel$interopDefault($hzVqu)))(this.currentView).find('.play-card-stack__card-face');
        if (visible) {
            this.currentSide = 'front';
            side.show();
            this._fitSideText(side);
        } else side.hide();
    }
    _displayBack(visible) {
        const side = (0, (/*@__PURE__*/$parcel$interopDefault($hzVqu)))(this.currentView).find('.play-card-stack__card-back');
        if (visible) {
            this.currentSide = 'back';
            side.show();
            this._fitSideText(side);
        } else side.hide();
    }
    _fireProgress() {
        this.progresser(this.progress);
    }
    shuffle() {
        this._shuffle();
        this.currentIndex = -1;
        this.start();
    }
    _isBothDisplayMode() {
        return this.displayMode === 'both';
    }
    toggleBoth() {
        if (this.displayMode === 'side') {
            this.displayMode = 'both';
            this._displayFace(true);
            this._displayBack(true);
        } else {
            this.displayMode = 'side';
            this._displayFace(true);
            this._displayBack(false);
        }
        this.displayModeChanged();
    }
}
$parcel$global.PackPlay = $8ee82b35ce3d87b9$var$PackPlay;

})();
//# sourceMappingURL=PackPlay.js.map
